import type { CustomTooltipProps } from 'ag-grid-react'
import type { ReactElement } from 'react'
import type { IRole } from '~/types/role'

const CustomTooltip = ({ data }: CustomTooltipProps<IRole>): ReactElement | null => {
  if (!data) return null

  const { description, name } = data

  return (
    <div className="custom-tooltip" style={{ backgroundColor: '#fff', border: '0.1rem solid #eee', padding: '1rem' }}>
      <span>{name}</span>
      {description.length ? (
        <>
          <br />
          <span>{description}</span>
        </>
      ) : null}
    </div>
  )
}

export default CustomTooltip
